const useElementHeight = (elementRef) => {
  const el = elementRef.current;

  if (!el) return 0;

  let prevValue = Math.floor(el.getBoundingClientRect().height);

  const handle = setInterval(() => {
    const nextValue = Math.floor(el.getBoundingClientRect().height);

    if (nextValue === prevValue) {
      clearInterval(handle);
    } else {
      prevValue = nextValue;
    }
  }, 500);

  return prevValue;
};

export default useElementHeight;
